import uuid from "uuid-js";
import { fetchEndpoint } from "@/server/network";
import Axios from "axios";
import axios from "axios";
import Swal from "sweetalert2";
import TcVod from "vod-js-sdk-v6";
import { DateRangePicker } from "tdesign-vue";

const warning = function(message) {
  Swal.fire({
    title: message,
    icon: "error",
    showCloseButton: false,
  });
};
//后台通过url转存文件
const saveFile = function(params) {
  return fetchEndpoint("/upload/dump", "POST", params);
};

//将视频，图片，音频存到vod
const saveToVod = function(params) {
  return fetchEndpoint("/resource/dump", "POST", params);
};

const list = function(params) {
  return fetchEndpoint("/resource/files", "GET", params);
};
const deleteFile = function(params) {
  return fetchEndpoint("/resource/delete/file", "post", params);
};
const addDir = function(params) {
  return fetchEndpoint("/resource/add/dir", "post", params);
};
const getFile = function(id) {
  return fetchEndpoint("/resource/file/info?id=" + id, "get");
};
const update = function(params) {
  return fetchEndpoint("/resource/modify", "post", params);
};
const addFile = function(params) {
  return fetchEndpoint("/resource/add/file", "post", params);
};
const getToken = function() {
  return fetchEndpoint("/resource/token", "get");
};

//富文本批量上传存到媒资库
const saveToVodBatch = function(params) {
  return fetchEndpoint("/upload/dump/batch", "POST", params);
};
// Axios.interceptors.request.use(
//   (config) => {
//     console.log("请求配置", config);
//     return config;
//   },
//   (error) => {
//     return error;
//   }
// );

// Axios.interceptors.response.use(
//   (response) => {
//     return response;
//   },
//   (error) => {
//     return error;
//   }
// );
let vod_file = {};
let classId = 932563; //视频分类ID 932563 音频分类ID 932968
let vod_name = "";
let fileType = "";
const getSignature = async function() {
  let signature;
  // let str = "" + vod_file.lastModified + vod_file.size;
  // let obj = localStorage[str];
  // if (obj) {
  //   let obj1 = JSON.parse(obj);
  //   vod_name = obj1.name;
  //   let time = new Date().getTime();
  //   return obj1.signature;
  // }
  let params = {
    classId:
      vod_file.type.indexOf("video") == "-1" ? env.vod_audio : env.vod_video,
    type: "",
  };
  if (fileType == "video") {
    params.type = "video";
    params.procedure = "LongVideoPreset";
  }
  await fetchEndpoint("/upload/vod/sign", "get", params).then((res) => {
    if (res.code === 0) {
      // console.log("签名信息", res);
      signature = res.data;
      // localStorage[str] = JSON.stringify({
      //   signature: signature,
      //   time: new Date().getTime(),
      //   name: vod_name,
      // });
    } else {
      warning(res.msg);
      console.log(res);
    }
  });
  return signature;
};

const uploadSlice = async function(file, filePath, rate, _params) {
  sessionStorage.setItem(rate, "0");
  console.log("rate", rate);
  vod_file = file;
  // console.log("file", file);
  let fileName =
    uuid.create() +
    "." +
    file.name
      .split(".")
      .splice(-1, 1)[0]
      .toLowerCase();
  vod_name = fileName;
  let size = file.size;
  if (filePath == "/video" || filePath == "/audio") {
    fileType = filePath == "/video" ? "video" : "audio";
    const tcVod = new TcVod({
      getSignature: getSignature, // 前文中所述的获取上传签名的函数
      // appId: 1500015226,
    });
    const uploader = tcVod.upload({
      mediaFile: file,
      mediaName: vod_name,
    });
    uploader.on("media_progress", (info) => {
      // console.log("进度信息", info);
      sessionStorage.setItem(rate, Math.floor(info.percent * 100) + "");
    });
    // 视频上传完成时
    uploader.on("media_upload", function(info) {
      console.log("上传完成", info);
    });
    await uploader
      .done()
      .then((res) => {
        console.log("done", res);
        let vod_url = res.video.url.split("://")[1];
        vod_url = vod_url.substr(vod_url.indexOf("/") + 1).replaceAll("/", "+");
        let params = {
          path: filePath + "/" + vod_url,
          file: fileName,
          size: size,
        };
        params.title = _params.title;
        params.type = _params.type;
        console.log("添加参数", params);
        addFile(params).then((res) => {
          if (res.code === 0) {
            sessionStorage.setItem(rate, "000");
          } else {
            sessionStorage.setItem(rate, "00");
          }
        });
      })
      .catch((res) => {
        console.log("错误信息", res);
        sessionStorage.setItem(rate, "00");
      });
    console.log("上传真正地完成了");
    return {};
  }

  let piece = 52428800; //分块大小50MB
  let arr_file = [];
  let num = Math.ceil(size / piece);
  let result = { result: false, msg: "上传文件出错", data: {} };
  let error = "";
  let isTrue = false;
  if (size <= piece) {
    arr_file.push(file);
  } else {
    for (let a = 0; a < num; a++) {
      arr_file.push(file.slice(a * piece, (a + 1) * piece));
    }
  }
  // console.log("文件", arr_file);
  let AccessToken = "";
  let LibraryId = "";
  let SpaceId = "-";
  let UserId = "";
  let Url = "";
  let path = filePath.substr(1) + "/" + fileName;
  let host = "https://smh.tencentcs.com";
  let params = {}; //上传需要的参数
  let ConflictMethod = "rename";
  //获取上传凭证
  await getToken().then((res) => {
    if (res.code === 0) {
      // console.log("上传凭证", res);
      let arr = res.data.split(",");
      AccessToken = arr[0];
      LibraryId = arr[1];
      isTrue = true;
    } else {
      result.msg = res.msg;
    }
  });
  if (isTrue) {
    isTrue = false;
  } else {
    sessionStorage.setItem(rate, "00");
    return Promise.resolve(result);
  }
  // 检查文件夹是否存在，不存在就创建
  let checkFloder = false;
  Url = `${host}/api/v1/directory/${LibraryId}/${SpaceId}/${filePath.substr(
    1
  )}?access_token=${AccessToken}`;
  await Axios.head(Url, {
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  }).then((res) => {
    console.log("文件夹检查结果", res);
    if (res) {
      console.log("文件夹存在");
      checkFloder = true;
    }
  });
  if (!checkFloder) {
    Url = `${host}/api/v1/directory/${LibraryId}/${SpaceId}/${filePath.substr(
      1
    )}?conflict_resolution_strategy=ask&access_token=${AccessToken}`;
    await Axios.put(Url).then((res) => {
      console.log("文件夹创建结果", res);
    });
  }
  // return;
  Url = `${host}/api/v1/file/${LibraryId}/${SpaceId}/${path}?multipart&conflict_resolution_strategy=${ConflictMethod}&access_token=${AccessToken}`;
  await Axios.post(Url).then((res) => {
    // console.log("获取上传参数", res);
    if (res.confirmKey) {
      params = res;
      isTrue = true;
    }
  });
  if (isTrue) {
    isTrue = false;
  } else {
    sessionStorage.setItem(rate, "00");
    return Promise.resolve(result);
  }
  let time_total = 2 * 60 * 60 * 1000; //上传有效期2小时
  let time_start = new Date().getTime();
  let time_end = undefined;
  let time_use = undefined;
  for (let b = 0; b < num; b++) {
    Url = `https://${params.domain}${params.path}?uploadId=${params.uploadId}&partNumber=`;
    // console.log("上传第" + (b + 1) + "个文件");
    await Axios.put(Url + (b + 1), arr_file[b], {
      onUploadProgress: (progressEvent) => {
        let persent = Math.round(
          (((progressEvent.loaded + b * piece) / size) * 100) | 0
        ); //上传进度百分比
        // console.log("进度", persent, progressEvent);
        sessionStorage.setItem(rate, persent);
      },
      headers: params.headers,
    }).then((res) => {
      // console.log("上传结果", res);
      if (!res) {
        isTrue = true;
      }
    });
    if (isTrue) {
      isTrue = false;
    } else {
      sessionStorage.setItem(rate, "00");
      return Promise.resolve(result);
    }
    //用时接近剩余时间一半时续期
    time_end = new Date().getTime();
    time_use = time_end - time_start;
    if (time_use / time_total > 0.46) {
      let addUrl = `${host}/api/v1/file/${LibraryId}/${SpaceId}/${params.confirmKey}?renew&conflict_resolution_strategy=${ConflictMethod}&access_token=${AccessToken}&user_id=${UserId}`;
      await axios.post(addUrl).then((res) => {
        // console.log("续期结果", res);
        if (res.confirmKey) {
          isTrue = true;
        }
        params = res;
        time_total = 2 * 60 * 60 * 1000; //续期有效期从现在开始2小时
      });
      if (isTrue) {
        isTrue = false;
      } else {
        sessionStorage.setItem(rate, "00");
        return Promise.resolve(result);
      }
    } else {
      time_total -= time_use;
      time_start = new Date().getTime();
    }
  }

  Url = `${host}/api/v1/file/${LibraryId}/${SpaceId}/${params.confirmKey}?confirm&conflict_resolution_strategy=${ConflictMethod}&access_token=${AccessToken}&user_id=${UserId}`;
  await Axios.post(Url).then((res) => {
    // console.log("上传完成", res);
    if (res.name) {
      result.data = {
        path: "/" + path,
        file: fileName,
        size: size,
      };
      isTrue = true;
    } else {
      sessionStorage.setItem(rate, "00");
    }
  });
  if (isTrue) {
    // console.log("开始调用添加接口");
    let params = result.data;
    params.title = _params.title;
    params.type = _params.type;
    console.log("文件添加参数", params);
    await addFile(params).then((res) => {
      if (res.code === 0) {
        result.result = true;
        sessionStorage.setItem(rate, "000");
      } else {
        sessionStorage.setItem(rate, "00");
      }
    });
  } else {
    sessionStorage.setItem(rate, "00");
    return Promise.resolve(result);
  }
  return Promise.resolve(result);
};

const getVodPath = function(params) {
  return fetchEndpoint("/upload/vod/url", "get", params);
};
const getDownloadUrl = async function(filePath) {
  let AccessToken = "";
  let LibraryId = "";
  let SpaceId = "-";
  let UserId = "";
  let host = "https://smh.tencentcs.com";
  let path = filePath.substr(1);
  let result = {
    result: false,
    url: "",
  };
  let isTrue = false;
  await getToken().then((res) => {
    if (res.code === 0) {
      // console.log("凭证", res);
      let arr = res.data.split(",");
      AccessToken = arr[0];
      LibraryId = arr[1];
      isTrue = true;
    } else {
      result.msg = res.msg;
    }
  });
  let url = `${host}/api/v1/file/${LibraryId}/${SpaceId}/${path}?info&content_disposition=attachment&access_token=${AccessToken}&user_id=${UserId}`;
  await axios.get(url).then((res) => {
    if (res.cosUrl) {
      result.url = res.cosUrl;
      result.result = true;
    } else {
      console.log(res);
    }
  });
  return Promise.resolve(result);
};

const vodDownload = async function(url, rate) {
  let index = url
    .split("/")
    .splice(-1, 1)[0]
    .indexOf("."); //验证是否有后缀名
  sessionStorage.setItem(rate, "0");
  let name = url
    .split("?")[0]
    .split("/")
    .splice(-1, 1)[0];
  axios(url, {
    method: "get",
    responseType: "blob",
    onDownloadProgress: (evt) => {
      const progress = parseInt((evt.loaded / evt.total) * 100);
      // console.log("进度", progress);
      sessionStorage.setItem(rate, progress);
    },
  })
    .then((res) => {
      // console.log("下载结果", res);
      let blob;
      if (index == -1) {
        blob = new Blob([res.data], { type: "image/png" });
      } else {
        blob = new Blob([res.data]);
      }
      const a = document.createElement("a");
      if (index == -1) {
        a.download = name + ".png";
      } else {
        a.download = name;
      }
      a.href = URL.createObjectURL(blob);
      a.click();
      URL.revokeObjectURL(a.href);
      a.remove();
    })
    .catch((error) => {
      warning("下载出错");
      console.log(error);
    });
};

const downloadFile = async function(url, rate) {
  sessionStorage.setItem(rate, "0");
  let name = url
    .split("?")[0]
    .split("/")
    .splice(-1, 1)[0];
  // let type = "image/" + name.split(".").splice(-1, 1)[0].toLowerCase();
  // console.log("文件类型", type);
  console.log("标题", name);
  let file;
  await axios(url, {
    method: "get",
    responseType: "blob",
    // headers: { Accept: type },
    onDownloadProgress: (evt) => {
      const progress = parseInt((evt.loaded / evt.total) * 100);
      console.log("下载进度", progress);
      // sessionStorage.setItem(rate, progress);
    },
  })
    .then((res) => {
      console.log("下载结果", res);
      file = new File([res.data], name, { type: res.data.type });
      console.log("文件", file);
      // const blob = new Blob([res.data]);
      // const a = document.createElement("a");
      // a.download = name;
      // a.href = URL.createObjectURL(blob);
      // a.click();
      // URL.revokeObjectURL(a.href);
      // a.remove();
    })
    .catch((error) => {
      warning("下载出错");
      console.log(error);
    });
  return file;
};

const imageToVod = async function(file, filePath, rate, _params) {
  sessionStorage.setItem(rate, "0");
  console.log("rate", rate);
  vod_file = file;
  // console.log("file", file);
  let fileName =
    uuid.create() +
    "." +
    file.name
      .split(".")
      .splice(-1, 1)[0]
      .toLowerCase();
  vod_name = fileName;
  let size = file.size;
  let piece = 52428800; //分块大小50MB
  let arr_file = [];
  let num = Math.ceil(size / piece);
  let result = { result: false, msg: "上传文件出错", data: {} };
  let error = "";
  let isTrue = false;
  if (size <= piece) {
    arr_file.push(file);
  } else {
    for (let a = 0; a < num; a++) {
      arr_file.push(file.slice(a * piece, (a + 1) * piece));
    }
  }
  // console.log("文件", arr_file);
  let AccessToken = "";
  let LibraryId = "";
  let SpaceId = "-";
  let UserId = "";
  let Url = "";
  let path = filePath.substr(1) + "/" + fileName;
  let host = "https://smh.tencentcs.com";
  let params = {}; //上传需要的参数
  let ConflictMethod = "rename";
  //获取上传凭证
  await getToken().then((res) => {
    if (res.code === 0) {
      // console.log("上传凭证", res);
      let arr = res.data.split(",");
      AccessToken = arr[0];
      LibraryId = arr[1];
      isTrue = true;
    } else {
      result.msg = res.msg;
    }
  });
  if (isTrue) {
    isTrue = false;
  } else {
    sessionStorage.setItem(rate, "00");
    return Promise.resolve(result);
  }
  // 检查文件夹是否存在，不存在就创建
  let checkFloder = false;
  Url = `${host}/api/v1/directory/${LibraryId}/${SpaceId}/${filePath.substr(
    1
  )}?access_token=${AccessToken}`;
  await Axios.head(Url, {
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  }).then((res) => {
    console.log("文件夹检查结果", res);
    if (res) {
      console.log("文件夹存在");
      checkFloder = true;
    }
  });
  if (!checkFloder) {
    Url = `${host}/api/v1/directory/${LibraryId}/${SpaceId}/${filePath.substr(
      1
    )}?conflict_resolution_strategy=ask&access_token=${AccessToken}`;
    await Axios.put(Url).then((res) => {
      console.log("文件夹创建结果", res);
    });
  }
  // return;
  Url = `${host}/api/v1/file/${LibraryId}/${SpaceId}/${path}?multipart&conflict_resolution_strategy=${ConflictMethod}&access_token=${AccessToken}`;
  await Axios.post(Url).then((res) => {
    // console.log("获取上传参数", res);
    if (res.confirmKey) {
      params = res;
      isTrue = true;
    }
  });
  if (isTrue) {
    isTrue = false;
  } else {
    sessionStorage.setItem(rate, "00");
    return Promise.resolve(result);
  }
  let time_total = 2 * 60 * 60 * 1000; //上传有效期2小时
  let time_start = new Date().getTime();
  let time_end = undefined;
  let time_use = undefined;
  for (let b = 0; b < num; b++) {
    Url = `https://${params.domain}${params.path}?uploadId=${params.uploadId}&partNumber=`;
    // console.log("上传第" + (b + 1) + "个文件");
    await Axios.put(Url + (b + 1), arr_file[b], {
      onUploadProgress: (progressEvent) => {
        let persent = Math.round(
          (((progressEvent.loaded + b * piece) / size) * 100) | 0
        ); //上传进度百分比
        // console.log("进度", persent, progressEvent);
        sessionStorage.setItem(rate, persent);
      },
      headers: params.headers,
    }).then((res) => {
      // console.log("上传结果", res);
      if (!res) {
        isTrue = true;
      }
    });
    if (isTrue) {
      isTrue = false;
    } else {
      sessionStorage.setItem(rate, "00");
      return Promise.resolve(result);
    }
    //用时接近剩余时间一半时续期
    time_end = new Date().getTime();
    time_use = time_end - time_start;
    if (time_use / time_total > 0.46) {
      let addUrl = `${host}/api/v1/file/${LibraryId}/${SpaceId}/${params.confirmKey}?renew&conflict_resolution_strategy=${ConflictMethod}&access_token=${AccessToken}&user_id=${UserId}`;
      await axios.post(addUrl).then((res) => {
        // console.log("续期结果", res);
        if (res.confirmKey) {
          isTrue = true;
        }
        params = res;
        time_total = 2 * 60 * 60 * 1000; //续期有效期从现在开始2小时
      });
      if (isTrue) {
        isTrue = false;
      } else {
        sessionStorage.setItem(rate, "00");
        return Promise.resolve(result);
      }
    } else {
      time_total -= time_use;
      time_start = new Date().getTime();
    }
  }

  Url = `${host}/api/v1/file/${LibraryId}/${SpaceId}/${params.confirmKey}?confirm&conflict_resolution_strategy=${ConflictMethod}&access_token=${AccessToken}&user_id=${UserId}`;
  await Axios.post(Url).then((res) => {
    // console.log("上传完成", res);
    if (res.name) {
      result.data = {
        path: "/" + path,
        file: fileName,
        size: size,
      };
      isTrue = true;
    } else {
      sessionStorage.setItem(rate, "00");
    }
  });
  if (isTrue) {
    // console.log("开始调用添加接口");
    let params = result.data;
    params.title = _params.title;
    params.type = _params.type;
    console.log("文件添加参数", params);
    await addFile(params).then((res) => {
      if (res.code === 0) {
        result.result = true;
        sessionStorage.setItem(rate, "000");
      } else {
        sessionStorage.setItem(rate, "00");
      }
    });
  } else {
    sessionStorage.setItem(rate, "00");
    return Promise.resolve(result);
  }
  return Promise.resolve(result);
};

export {
  saveFile,
  list,
  deleteFile,
  addDir,
  addFile,
  getFile,
  update,
  getToken,
  uploadSlice,
  getDownloadUrl,
  warning,
  getVodPath,
  vodDownload,
  saveToVod,
  saveToVodBatch,
  downloadFile,
};
